var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"text-ontick-large font-bold text-ontick-steel-900 dark:text-gray-300"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }